"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    closeIconSizeTiny: '12px',
    closeIconSizeSmall: '12px',
    closeIconSizeMedium: '14px',
    closeIconSizeLarge: '14px',
    closeSizeTiny: '16px',
    closeSizeSmall: '16px',
    closeSizeMedium: '18px',
    closeSizeLarge: '18px',
    padding: '0 7px',
    closeMargin: '0 0 0 4px',
    closeMarginRtl: '0 4px 0 0'
};
